// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamDetailInviteesRow_container__3FTsw","content":"TeamDetailInviteesRow_content__19q3M"};